import { cn } from '@/lib/utils'

import { PageBreakStylesProps } from './page-break-switch'

export const ThinLine = ({ className }: PageBreakStylesProps) => {
  return (
    <div className={cn('w-full border-t border-page-divider', className)} />
  )
}
